import * as types from "./mutations-types";

export default {
    [types.SET_LIST_CREDIT_CARD](state, credit_cards) {
        state.credit_cards = credit_cards;
    },
    [types.SET_LIST_CREDIT_CARD_TOTAL_INVOICE](state, credit_cards_total_invoice) {
        state.credit_cards_total_invoice = credit_cards_total_invoice;
    }
};